import { format } from "d3-format";
import React, { Component } from "react";
import PropTypes from "prop-types";

import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";

import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";
import { functor } from "../utils";

class RSICutlerTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }

  renderSVG(moreProps) {
    const {
      onClick,
      origin: originProp,
      className,
      fontFamily,
      fontSize,
      labelFill,
      textFill,
      displayFormat,
      yAccessor,
      options,
      appearance,
    } = this.props;

    const origin = functor(originProp);
    const {
      chartConfig: { width, height },
    } = moreProps;
    const [x, y] = origin(width, height);

    const currentItem = this.props.displayValuesFor(this.props, moreProps);
    const value = currentItem && yAccessor(currentItem);

    const rsiValue =
      value && Number.isFinite(value.rsi) ? displayFormat(value.rsi) : "n/a";
    const emaValue =
      value && Number.isFinite(value.emaRsi)
        ? displayFormat(value.emaRsi)
        : "n/a";

    const period = options?.period;
    const rsiColor = appearance?.strokeRsi?.color || "#FFFF00";
    const emaColor = appearance?.strokeEmaRsi?.color || "#FF0000";

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-rsicutler"
      >
        <ToolTipText
          fontFamily={fontFamily}
          fontSize={fontSize}
          fill={textFill}
        >
          <ToolTipTSpanLabel fill={labelFill}>IFR Cutler</ToolTipTSpanLabel>
          <ToolTipTSpanLabel
            fill={labelFill}
          >{` (${period ?? "?"})`}</ToolTipTSpanLabel>
          <ToolTipTSpanLabel fill={labelFill}> IFR: </ToolTipTSpanLabel>
          <tspan fill={rsiColor}>{rsiValue}</tspan>
          <ToolTipTSpanLabel fill={labelFill}> Sinal: </ToolTipTSpanLabel>
          <tspan fill={emaColor}>{emaValue}</tspan>
        </ToolTipText>
      </g>
    );
  }

  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

RSICutlerTooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  labelFill: PropTypes.string,
  textFill: PropTypes.string,
  displayFormat: PropTypes.func,
  yAccessor: PropTypes.func.isRequired,
  options: PropTypes.object,
  appearance: PropTypes.object,
  displayValuesFor: PropTypes.func,
  onClick: PropTypes.func,
};

RSICutlerTooltip.defaultProps = {
  origin: [0, 10],
  className: "react-stockcharts-tooltip react-stockcharts-rsicutler-tooltip",
  fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
  fontSize: 11,
  labelFill: "#4682B4",
  textFill: "#000000",
  displayFormat: format(".1f"),
  displayValuesFor,
  onClick: undefined,
};

export default RSICutlerTooltip;
